export default [{
	path: 'product',
	meta: {
		title: '商品管理'
	},
	component: () => import('@/pages/sales/product')
}, {
	path: 'product/abnormal',
	meta: {
		title: '下架异常商品'
	},
	component: () => import('@/pages/sales/product_abnormal')
}, {
	path: 'product/report',
	meta: {
		title: '质检报告'
	},
	props: route => route.query,
	component: () => import('@/pages/sales/product_report')
}, {
	path: 'order/online',
	meta: {
		title: '线上同售订单'
	},
	component: () => import('@/pages/sales/order_online')
}, {
	path: 'order/online/extra',
	meta: {
		title: '超卖订单'
	},
	component: () => import('@/pages/sales/order_online_extra')
}, {
	path: 'order/offline',
	meta: {
		title: '线下订单'
	},
	component: () => import('@/pages/sales/order_offline')
}, {
	path: 'order/offline/create',
	meta: {
		title: '新建线下订单'
	},
	component: () => import('@/pages/sales/order_offline_create')
}]